
import { Component, Vue, Watch } from "vue-property-decorator";
import { SMApp } from "@/store";
import { API_ROUTES } from "@/utils/API";
import { API_TNote, TNote, TNote_Table, convertNotesForTable } from "@/models/case_notes";
import vueEditorOptions from "@/plugins/vue-editor/options-default";

@Component
export default class AdvisorNotes extends Vue {
  notes: TNote_Table[] = [];
  message = "";
  loading = true;
  isSendIconVisible = false;

  editorOptions = vueEditorOptions.editorSettingsNoHeader;
  customModulesForEditor = vueEditorOptions.customModulesForEditor;

  get noteActive() {
    return SMApp.noteActive;
  }

  get caseId() {
    return this.$route.params.id;
  }

  get advisorNotesPath() {
    return `/expert/cases/${this.caseId}/activity`;
  }

  get isDashboard() {
    return this.$route.meta.tabName === "dashboard";
  }

  @Watch("noteActive")
  noteActiveChanged(isActive: boolean) {
    this.$emit("showNotes", isActive);
  }

  created() {
    this.getNotes();
  }

  getNotes() {
    this.axios.get(API_ROUTES.CASE_ACTIVITY_LOG_LIMIT(this.caseId, 5)).then(({ data }) => {
      this.setNotes(data);
      this.loading = false;
    });
  }

  setNotes(notes: API_TNote[]) {
    this.notes = notes.map((note) => convertNotesForTable(note));
  }

  leaveMessage() {
    if (!this.message) return;

    const data: TNote = {
      message: this.message,
    };

    this.axios.post(API_ROUTES.CASE_ACTIVITY_LOG(this.caseId), data).then(() => {
      this.getNotes();
      this.message = "";
    });
  }

  avatarLetter(letter: string) {
    return letter.charAt(0).toUpperCase() || "U";
  }

  atFocusInput() {
    this.isSendIconVisible = true;
  }

  atBlurInput() {
    this.isSendIconVisible = false;
  }

  beforeDestroy() {
    SMApp.hideNotes();
    this.atBlurInput();
  }
}
